import { header } from "./js/header";
import { faq } from "./js/faq";
import { gallerySlider } from "./js/gallerySlider";
import { reviewsSlider } from "./js/reviewsSlider";
import { scrollUp } from "./js/scrollUp.js";

header()
faq()
gallerySlider()
reviewsSlider()
scrollUp()